import { SHOW_TOAST, HIDE_TOAST } from "./toastActions";

const initialState = {
  open: false,
  message: "",
  severity: "success", 
};

const toastReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_TOAST:
      return {
        ...state,
        open: true,
        message: action.payload.message,
        severity: action.payload.severity,
      };
    case HIDE_TOAST:
      return {
        ...state,
        open: false,
      };
    default:
      return state;
  }
};

export default toastReducer;